import { useState } from "react";
import { useTranslation } from "react-i18next";
import { TeambookProjectsPicker } from "../../default_components/TeambookDefaultPickers";
import TeambookDialog from "../../default_components/TeambookDialog";
import PropTypes from "prop-types";

const AddProjectDialog = ({ handleClose, allProjects, visibleProjectIds, addProjects }) => {
  const { t } = useTranslation();
  const [selectedProjects, setSelectedProjects] = useState([]);

  return (
    <TeambookDialog
      title={t("planning.add_projects_to_screen")}
      open={true}
      onClose={handleClose}
      withCloseButton
      content={
        <TeambookProjectsPicker
          displayEmpty={true}
          projects={allProjects.filter((pr) => !visibleProjectIds.includes(pr.id))}
          defaultValue={[]}
          placeholder={t("planning.select_projects")}
          maxMenuHeight={150}
          type="multiple"
          onChange={(options) => {
            setSelectedProjects(Array.isArray(options) ? options : []);
          }}
          isSearchable={true}
        />
      }
      actionButtons={[
        {
          text: t("save"),
          onClick: () => addProjects(selectedProjects),
          id: "save",
        },
      ]}
    />
  );
};

AddProjectDialog.propTypes = {
  handleClose: PropTypes.func.isRequired,
  allProjects: PropTypes.array.isRequired,
  visibleProjectIds: PropTypes.array.isRequired,
  addProjects: PropTypes.func.isRequired,
};

export default AddProjectDialog;
